import React, { Component } from "react";
import { connect } from "react-redux";
import { changeSwModeAction, changeEditerModeAction, changeInPredictAction, changeImpWSAction } from "../../redux/app/actions";
import { regEditerAction } from "../../redux/editer/actions";
import { changeRegionAction, changeCoordAction } from "../../redux/modelArea/actions";
import { openSwAction } from "../../redux/ui/actions";
import Select from "../common/Select";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        region: state.modelAreaReducer.region,
        coord: state.modelAreaReducer.coord,
        paramRegion: state.paramReducer.region,
        boringDs: state.boringReducer.dataset,
    };
};
class Main extends Component {
    constructor(props) {
        super(props);
        //地域オプション
        //this.envKind = [{ val: '0', text: '流域界' }, { val: '1', text: 'AA' }, { val: '2', text: 'BB' }, { val: '3', text: 'CC' }]; 今後読み込めるデータを増やす
        this.envKind = [{ val: "0", text: "流域界" }];
        this.closeSw = this.closeSw.bind(this);
        this.waiting = this.waiting.bind(this);
        this.changeEnvData = this.changeEnvData.bind(this);
    }

    /*
     * インポートする環境データを変更する。
     * @since ando 2025-03-27
     */
    changeEnvData() {}

    waiting = (stat) => {
        this.props.dispatch(changeInPredictAction(stat));
    };

    /*
     * 環境データインポート
     * @since ando 2024-03-27
     */
    async envDataImport() {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.onchange = async (event) => {
            const file = event.target.files[0];
            const formData = new FormData();

            if (!file) {
                return;
            }
            const fileSizeInBytes = file.size;
            const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // バイトをMBに変換

            if (fileSizeInMB > 50) {
                alert("50MB以上のファイルはアップロードできません。");
                return;
            } else {
                const fileName = file.name; // ファイル名を取得
                const fileNameWithoutExtension = fileName.lastIndexOf(".") !== -1 ? fileName.substring(0, fileName.lastIndexOf(".")) : fileName;
                const origin = window.location.origin;
                const search = window.location.search;

                formData.append("zipFile", file); // FormDataにファイルを追加

                try {
                    this.waiting(true);
                    const response = await fetch(`${origin}/api/importWS/${search}`, {
                        method: "POST",
                        body: formData, // FormDataを直接送信
                    });
                    const data = await response.json();
                    if (!data.upload) {
                        alert(
                            "このファイルはアップロードできません。\n下記サイトから全国の流域界データをダウンロードしてください。\nhttps://nlftp.mlit.go.jp/ksj/gmlold/datalist/gmlold_KsjTmplt-W12.html",
                        );
                        this.waiting(false);
                    } else {
                        // インポートが成功した場合の処理
                        this.props.dispatch(changeImpWSAction(true));
                        setInterval(
                            //ファイル読込処理が一瞬だとローディング画面と認識されなさそうなので、意図的に0.5秒待つ
                            () => this.waiting(false),
                            500,
                        );
                    }
                } catch (error) {
                    this.waiting(false);
                    console.error("ファイルのインポート中にエラーが発生しました。", error);
                }
            }
        };
        fileInput.click(); // ファイル選択ダイアログを開く
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2020-09-09
     */
    closeSw() {
        this.props.dispatch(openSwAction(null));
        this.props.dispatch(changeSwModeAction(0));
    }
    render() {
        return (
            <Sw title="環境データ" focusName="area">
                <Select label="種別" options={this.envKind} value={this.props.region} class="selectM" blank={false} action={null} change={this.changeEnvData} />
                <div className="l-right l-mtM">
                    <button className="cBtn" onClick={() => this.envDataImport()}>
                        インポート
                    </button>
                    <button className="cBtn l-mlS" onClick={this.closeSw}>
                        閉じる
                    </button>
                </div>
            </Sw>
        );
    }
}

export default connect(mapStateToProps)(Main);
